import { render, staticRenderFns } from "./PopupNotice.vue?vue&type=template&id=24639bd2&scoped=true&lang=pug"
import script from "./PopupNotice.vue?vue&type=script&lang=js"
export * from "./PopupNotice.vue?vue&type=script&lang=js"
import style0 from "./PopupNotice.vue?vue&type=style&index=0&id=24639bd2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24639bd2",
  null
  
)

export default component.exports